export default "__VITE_ASSET__DD_jfUhs__"